import { render, staticRenderFns } from "./BaTraderAllHoldings.vue?vue&type=template&id=7c50cb7b&scoped=true&"
import script from "./BaTraderAllHoldings.vue?vue&type=script&lang=js&"
export * from "./BaTraderAllHoldings.vue?vue&type=script&lang=js&"
import style0 from "./BaTraderAllHoldings.vue?vue&type=style&index=0&id=7c50cb7b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c50cb7b",
  null
  
)

export default component.exports